<template>
  <v-content>
    <v-container fill-height="fill-height">
      <v-layout
        align-center="align-center"
        justify-center="justify-center"
      >
        <v-flex
          text-xs-center
          pa-3
          lg4
          md5
          xl3
        >
          <div class="display-1 mb-3">
            <img
              class="card-img-top"
              aspect-ratio="1"
              src="template/accueil/images/rimborsi-spese.png"
            >
            <img
              class="card-img-top"
              src="template/accueil/images/accueil.png"
              alt="Accueil SRC"
            >
          </div>
          <v-card
            light
            class="pa-4 elevation-0 login-form"
            color="transparent"
          >
            <v-card-text>
              <form 
                ref="form" >
                <input 
                  ref="login"
                  v-model="login"
                  :rules="[
                    () => !!login || 'Campo obbligatorio!'
                  ]"
                  placeholder="Login Accueil" 
                  required >
                <input 
                  ref="password"
                  v-model="password"
                  :rules="[
                    () => !!password || 'Campo obbligatorio!',
                    () => !!password && password.length >= 5 || 'Password deve avere almeno 5 carateri'
                  ]"
                  type="password" 
                  placeholder="Password" 
                  required 
                  @keyup.enter="submit">
              </form>
            </v-card-text>
            <p
              v-if="submitState.status === 'ERROR'"
              class="blockquote-footer red"
              v-html="submitState.textError" />
            <p
              v-if="submitState.status === 'PENDING'"
              class="blockquote-footer red"
            >Processing...</p>
            <v-divider class="mt-2" />
            <v-card-actions>
              <v-spacer />
              <v-slide-x-reverse-transition>
                <v-tooltip
                  v-if="submitState.status === 'ERROR'"
                  left
                >
                  <v-btn
                    slot="activator"
                    icon
                    class="my-0"
                    @click="resetForm"
                  >
                    <v-icon>refresh</v-icon>
                  </v-btn>
                  <span>Svota</span>
                </v-tooltip>
              </v-slide-x-reverse-transition>
              <v-btn
                :disabled="submitState.status === 'PENDING'"
                color="red"
                raised
                flat
                @click="resetPasswordHandler"
              >Reset password</v-btn>
              <v-btn
                :disabled="submitState.status === 'PENDING'"
                color="secondary"
                raised
                @click="submit"
              >Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { Login } from "../stores";
import { mapMutations } from "vuex";

export default {
  data: () => ({
    options: {
      errorMessages: "",
      formHasErrors: false,
      show: false
    },
    login: "",
    password: ""
  }),
  computed: {
    pageData () {
      return this.$store.getters.getPageData;
    },
    submitState () {
      return {
        status: this.$store.getters.getStatus,
        textError: this.$store.getters.getTextError
      };
    },
    form () {
      return {
        login: this.login,
        password: this.password
      };
    }
  },
  beforeCreate () {
    document.body.className = 'body-personalized';
    this.$store.registerModule("pageStore", Login);
  },
  methods: {
    ...mapMutations(['UPDATE_TEXT_ERROR', 'UPDATE_STATUS']),
    resetForm () {
      this.$refs.form.reset()
    },
    submit () {
      if (this.form.login && this.form.password) {
        this.$store.commit("UPDATE_STATUS", "PENDING");
        this.$store.dispatch("login", this.form);
      } else {
        var mss = ''
        for (const key in this.form) {
          if (this.form.hasOwnProperty(key)) {
            const element = this.form[key];
            mss += !element ? '<p>Campo ' + key + ' obbligatorio</p>' : ''
          }
        }
        if (mss) {
          this.UPDATE_STATUS('ERROR')
          this.UPDATE_TEXT_ERROR(mss)
        }
      }
    },
    resetPasswordHandler () {
      if (!this.login) 
        return this.$swal.fire({
          type: 'error',
          html: `<p class=" mt-2 title">Attenzione! <br/><p class="mt-2 red--text text--darken-4 font-weight-bold font-italic">Per resettare la password login Accueil è obbligatorio.</p>`
        });
      this.$swal({
        type: 'warning',
        html: 'Sei sicuro di volere resettare password a <br/>' + this.login + ' ?',
        showCancelButton: true,
        confirmButtonText: 'Reset',
        cancelButtonText: 'Annulla',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.$store.dispatch('beforeResetPassword', {login: this.login})
            .catch(error => {
              this.$swal.showValidationMessage(
                `Request failed: ${error}`
              )
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.value && result.value.stato === 'success' && result.value.data.email) {
          this.$swal.fire({
            type: 'success',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
            showLoaderOnConfirm: true,
            html: `La nuova password per <span class="font-weight-bold">${this.login}</span> errà inviata al seguente indirizzo email: <p class=" mt-2 title font-weight-bold font-italic">${result.value.data.email}</p> <p class="caption font-weight-bold font-italic">*Se non è questo il tuo indirizzo di riferimento per le comunicazioni aziendali contatta RU.<p/>`,
            preConfirm: () => {
              return this.resetPassword(this.login)
                .catch(error => {
                  this.$swal.showValidationMessage(
                    `Request failed: ${error}`
                  )
                })
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else if (result.value) {
          this.$swal.fire({
            type: 'error',
            html: `<p class=" mt-2 title">Operazione fallita con messaggio <br/><p class="mt-2 red--text text--darken-4 font-weight-bold font-italic">"${result.value.textError}"</p>`
          })
        }
      })
    },
    resetPassword (login) {
      return this.$store.dispatch('resetPassword', {login})
      .then((result) => {
        if (result.stato === 'success') {
          this.$swal.fire({
            type: 'success',
            html: `Nuovo password temporanio inviato corettamente!`
          })
        } else {
          this.$swal.fire({
            type: 'error',
            html: `<p class=" mt-2 title">Operazione fallita con messaggio <br/><p class="mt-2 red--text text--darken-4 font-weight-bold font-italic">"${result.textError}"</p>`
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
body.body-personalized { 
	width: 100%;
	height:100%;
	font-family: 'Open Sans', sans-serif;
	background: #092756;
	background: -moz-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%),-moz-linear-gradient(top,  rgba(57,173,219,.25) 0%, rgba(42,60,87,.4) 100%), -moz-linear-gradient(-45deg,  #670d10 0%, #092756 100%);
	background: -webkit-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%), -webkit-linear-gradient(top,  rgba(57,173,219,.25) 0%,rgba(42,60,87,.4) 100%), -webkit-linear-gradient(-45deg,  #670d10 0%,#092756 100%);
	background: -o-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%), -o-linear-gradient(top,  rgba(57,173,219,.25) 0%,rgba(42,60,87,.4) 100%), -o-linear-gradient(-45deg,  #670d10 0%,#092756 100%);
	background: -ms-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%), -ms-linear-gradient(top,  rgba(57,173,219,.25) 0%,rgba(42,60,87,.4) 100%), -ms-linear-gradient(-45deg,  #670d10 0%,#092756 100%);
	background: -webkit-radial-gradient(0% 100%, ellipse cover, rgba(104,128,138,.4) 10%,rgba(138,114,76,0) 40%), linear-gradient(to bottom,  rgba(57,173,219,.25) 0%,rgba(42,60,87,.4) 100%), linear-gradient(135deg,  #670d10 0%,#092756 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3E1D6D', endColorstr='#092756',GradientType=1 );
  .application{
    background: inherit;
  }
}
</style>
<style lang="scss" scoped>
.login-form {
  
.btn { display: inline-block; *display: inline; *zoom: 1; padding: 4px 10px 4px; margin-bottom: 0; font-size: 13px; line-height: 18px; color: #333333; text-align: center;text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75); vertical-align: middle; background-color: #f5f5f5; background-image: -moz-linear-gradient(top, #ffffff, #e6e6e6); background-image: -ms-linear-gradient(top, #ffffff, #e6e6e6); background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#e6e6e6)); background-image: -webkit-linear-gradient(top, #ffffff, #e6e6e6); background-image: -o-linear-gradient(top, #ffffff, #e6e6e6); background-image: linear-gradient(top, #ffffff, #e6e6e6); background-repeat: repeat-x; filter: progid:dximagetransform.microsoft.gradient(startColorstr=#ffffff, endColorstr=#e6e6e6, GradientType=0); border-color: #e6e6e6 #e6e6e6 #e6e6e6; border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25); border: 1px solid #e6e6e6; -webkit-border-radius: 4px; -moz-border-radius: 4px; border-radius: 4px; -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05); -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05); box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05); cursor: pointer; *margin-left: .3em; }
.btn:hover, .btn:active, .btn.active, .btn.disabled, .btn[disabled] { background-color: #e6e6e6; }
.btn-large { padding: 9px 14px; font-size: 15px; line-height: normal; -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px; }
.btn:hover { color: #333333; text-decoration: none; background-color: #e6e6e6; background-position: 0 -15px; -webkit-transition: background-position 0.1s linear; -moz-transition: background-position 0.1s linear; -ms-transition: background-position 0.1s linear; -o-transition: background-position 0.1s linear; transition: background-position 0.1s linear; }
.btn-primary, .btn-primary:hover { text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); color: #ffffff; }
.btn-primary.active { color: rgba(255, 255, 255, 0.75); }
.btn-primary { background-color: #4a77d4; background-image: -moz-linear-gradient(top, #6eb6de, #4a77d4); background-image: -ms-linear-gradient(top, #6eb6de, #4a77d4); background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#6eb6de), to(#4a77d4)); background-image: -webkit-linear-gradient(top, #6eb6de, #4a77d4); background-image: -o-linear-gradient(top, #6eb6de, #4a77d4); background-image: linear-gradient(top, #6eb6de, #4a77d4); background-repeat: repeat-x; filter: progid:dximagetransform.microsoft.gradient(startColorstr=#6eb6de, endColorstr=#4a77d4, GradientType=0);  border: 1px solid #3762bc; text-shadow: 1px 1px 1px rgba(0,0,0,0.4); box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.5); }
.btn-primary:hover, .btn-primary:active, .btn-primary.active, .btn-primary.disabled, .btn-primary[disabled] { filter: none; background-color: #4a77d4; }
.btn-block { width: 100%; display:block; }
.login { 
	position: absolute;
	top: 50%;
	left: 50%;
	margin: -150px 0 0 -150px;
	width:300px;
	height:300px;
}
.login h1 { color: #fff; text-shadow: 0 0 10px rgba(0,0,0,0.3); letter-spacing:1px; text-align:center; }

input { 
	width: 100%; 
	margin-bottom: 10px; 
	background: rgba(0,0,0,0.3);
	border: none;
	outline: none;
	padding: 10px;
	font-size: 13px;
	color: #fff;
	text-shadow: 1px 1px 1px rgba(0,0,0,0.3);
	border: 1px solid rgba(0,0,0,0.3);
	border-radius: 4px;
	box-shadow: inset 0 -5px 45px rgba(100,100,100,0.2), 0 1px 1px rgba(255,255,255,0.2);
	-webkit-transition: box-shadow .5s ease;
	-moz-transition: box-shadow .5s ease;
	-o-transition: box-shadow .5s ease;
	-ms-transition: box-shadow .5s ease;
	transition: box-shadow .5s ease;
}
input:focus { box-shadow: inset 0 -5px 45px rgba(100,100,100,0.4), 0 1px 1px rgba(255,255,255,0.2); }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/pages/Login.vue